<template>
	<inertia-head title="Checkout" />
	<h2 class="text-center">Congratulations For Taking Action!</h2>
	<h6 v-if="opsRequest && opsRequest.mop == 'OVER_THE_COUNTER'" class="fw-bold text-center h4 mt-4 text-danger">
		Your membership subscription is now ready for payment. Please proceed to the payment counters.
	</h6>
	<h6 v-else class="text-center">Please follow This 2 Simple Steps To Enroll TODAY!</h6>
	<form @submit.prevent="submit">
		<!-- Step 1 -->
		<div v-if="form.step == 1">
			<div class="row">
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-6">
							<div class="form-floating mb-4">
								<input
									id="fname"
									v-model="form.fname"
									:class="{ 'is-invalid': form.errors.fname }"
									type="text"
									class="form-control"
									placeholder="Enter your fname"
								/>
								<label class="form-label" for="fname">First Name</label>
								<div v-if="form.errors.fname" class="invalid-feedback">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.fname }}
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-floating mb-4">
								<input
									id="lname"
									v-model="form.lname"
									:class="{ 'is-invalid': form.errors.lname }"
									type="text"
									class="form-control"
									placeholder="Enter your lname"
								/>
								<label class="form-label" for="lname">Last Name</label>
								<div v-if="form.errors.lname" class="invalid-feedback">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.lname }}
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-floating mb-4">
								<input
									id="email"
									v-model="form.email"
									:class="{ 'is-invalid': form.errors.email }"
									type="text"
									class="form-control"
									placeholder="Enter your email"
								/>
								<label class="form-label" for="email">Email address</label>
								<div v-if="form.errors.email" class="invalid-feedback">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.email }}
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="mb-4">
								<div class="row g-2 align-items-center birthday-select-row">
									<label class="form-label col-12 col-lg-auto mb-0" for="bday_month">Birthday</label>
									<div class="col-12 col-sm-5 col-lg">
										<select
											id="bday_month"
											v-model="birthMonth"
											class="form-select form-select-lg"
											:class="{ 'is-invalid': form.errors.bday }"
											aria-label="Birthday month"
										>
											<option value="" disabled>Month</option>
											<option
												v-for="month in birthMonths"
												:key="month.value"
												:value="month.value"
											>
												{{ month.label }}
											</option>
										</select>
									</div>
									<div class="col-6 col-sm-3 col-lg">
										<select
											id="bday_day"
											v-model="birthDay"
											class="form-select form-select-lg"
											:class="{ 'is-invalid': form.errors.bday }"
											aria-label="Birthday day"
										>
											<option value="" disabled>Day</option>
											<option
												v-for="day in birthDays"
												:key="day"
												:value="day"
											>
												{{ Number(day) }}
											</option>
										</select>
									</div>
									<div class="col-6 col-sm-4 col-lg">
										<select
											id="bday_year"
											v-model="birthYear"
											class="form-select form-select-lg"
											:class="{ 'is-invalid': form.errors.bday }"
											aria-label="Birthday year"
										>
											<option value="" disabled>Year</option>
											<option
												v-for="year in birthYears"
												:key="year"
												:value="String(year)"
											>
												{{ year }}
											</option>
										</select>
									</div>
								</div>
								<div v-if="form.errors.bday" class="invalid-feedback d-block">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.bday }}
								</div>
							</div>
						</div>
					</div>
					<div class="mb-4">
						<vue-tel-input
							:id="'mobile'"
							:value="form.mobile"
							@input="onInput"
							@countryChanged="onCountryChange"
							defaultCountry="PH"
							mode="international"
							:class="{ 'is-invalid': form.errors.mobile }"
							class="form-control"
							:input-options="{
								placeholder: 'Enter mobile number',
							}"
						/>
						<div v-if="form.errors.mobile" class="invalid-feedback">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.mobile }}
						</div>
					</div>
					<div class="block block-rounded">
						<div class="block-header block-header-default">
							<h3 class="block-title">Choose Subscription - 
								<span class="fw-bold badge"
									:set="img_bg=subscriptions[0].prefix=='S' ? '0891b2' 
									: (subscriptions[0].prefix=='G' ? 'FEC10D'
									: (subscriptions[0].prefix=='D' ? 'd97706'
									: (subscriptions[0].prefix=='P'	? '22844b'
									: (subscriptions[0].prefix=='PC'? '36b3a0'
									: (subscriptions[0].prefix=='PF'? '32a67f'
									: (subscriptions[0].prefix=='B' ? '8f55f2'
									: '343a40'
									))))))
									"
									:style="'background:#'+img_bg"
								>{{subscriptions[0].alias}}</span>
							</h3>
						</div>
						<div class="block-content">
							<div class="row">
								<div v-if="form.errors.subscription" class="col-12 text-danger mb-3">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.subscription }}
								</div>
								<div
									class="col-12"
									v-for="subscription in subscriptions"
									:key="subscription.prod_id"
								>
									<div class="form-check form-block mb-3">
										<input
											v-model="form.subscription"
											class="subscription form-check-input"
											type="radio"
											:id="subscription.prod_id"
											:value="subscription.prod_id"
											name="subscription"
										/>
										<label class="form-check-label" :for="subscription.prod_id">
											<span class="d-flex align-items-center">
												<h6 class="fs-sm mb-0">
													{{ subscription.membership }}
												</h6>
												<span
													v-if="subscription.add_display"
													class="badge bg-warning ms-1"
												>
													{{ subscription.add_display }}
												</span>
											</span>
											<small>
												<s v-if="subscription.is_promo==1" class="me-1">&#8369;{{ subscription.regular_amount }}</s>
												<span :class="{'fw-bold text-danger':subscription.is_promo==1}">&#8369;{{ subscription.amount }}</span>
												<span v-if="investment_plan!=null">
													+ Additional <span class="text-danger">&#8369;{{ investment_plan.amount }}</span> for {{investment_plan.invest_name}}
												</span>
												<div v-if="subscription.add_desc!=null">
													<div v-html="subscription.add_desc"></div>
												</div>
											</small>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="block block-rounded">
						<div class="block-header block-header-default">
							<h3 class="block-title">Choose Payment method</h3>
						</div>
						<div class="block-content">
							<p v-if="form.errors.mop" class="text-danger fw-semibold mb-3">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.mop }}
							</p>
							<div class="row">
								<div class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'CARD'"
											id="card"
											name="payment_method"
										/>
										<label class="form-check-label" for="card">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/stripe-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="isBirthdayLifetimeCheckout && isLifetimeSubscription" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'BANK_TRANSFER'"
											id="bank_transfer"
											name="payment_method"
										/>
										<label class="form-check-label" for="bank_transfer">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/bank_transfer.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="['','ph'].includes(isEvent) && payment_available" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY'"
											id="dragonpay"
											name="payment_method"
										/>
										<label class="form-check-label" for="dragonpay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/dragonpay.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="['','ph'].includes(isEvent) && payment_available && !(isBirthdayLifetimeCheckout && isLifetimeSubscription)" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY-GCASH'"
											id="dragonpay_gcash"
											name="payment_method"
										/>
										<label class="form-check-label" for="dragonpay_gcash">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/gcash.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="['noph','ph'].includes(isEvent) && (payment_available || (!payment_available && form.is_lifetime))" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'OVER_THE_COUNTER'"
											id="over_the_counter"
											name="payment_method"
										/>
										<label class="form-check-label" for="over_the_counter">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/overthecounter.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								
								<!-- <div class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.mop"
											class="form-check-input"
											type="radio"
											:value="'PAYNAMICS'"
											id="bropay"
											name="payment_method"
										/>
										<label class="form-check-label" for="bropay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/paynamics.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div> -->
							</div>
						</div>
					</div>
					<div class="mb-5">
						<div class="form-floating">
							<input
								type="text"
								class="form-control"
								id="coupon_code"
								v-model="form.coupon_code"
								:class="{ 'is-invalid': form.errors.coupon_code }"
								placeholder="Enter coupon code"
							/>
							<label class="form-label" for="coupon_code">Coupon Code</label>
							<div v-if="form.errors.coupon_code" class="invalid-feedback">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.coupon_code }}
							</div>
						</div>
						<i>Discount to be applied on the next page</i>
					</div>
				</div>
				<div class="col-md-12 mb-5">
					<div class="block block-rounded border">
						<div class="block-header block-header-default">
							<h3 class="block-title">Member benefits</h3>
						</div>
						<div class="block-content">
							<ul class="list-unstyled checkout-benefits-list mb-0">
								<li
									v-for="benefit in checkoutBenefits"
									:key="benefit"
									class="d-flex align-items-start mb-2"
								>
									<i class="fa fa-check text-success mt-1 me-2 flex-shrink-0"></i>
									<span>{{ benefit }}</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- Step 2 -->
		<div v-else>
			<div class="table-responsive">
				<table class="table table-striped table-borderless table-vcenter">
					<tbody>
						<tr>
							<th>First Name</th>
							<td>{{ opsRequest.fname }}</td>
						</tr>

						<tr>
							<th>Last Name</th>
							<td>{{ opsRequest.lname }}</td>
						</tr>
						<tr>
							<th>Email</th>
							<td>{{ opsRequest.email }}</td>
						</tr>
						<tr>
							<th>Mobile</th>
							<td>{{ opsRequest.mobile }}</td>
						</tr>
						<tr>
							<th>Subscription</th>
							<td>{{ opsRequest.course }}</td>
						</tr>
						<tr>
							<th>Amount</th>
							<td>
							<s v-if="opsRequest.less_amount>0" class="me-1">{{moneyFormat(opsRequest.actual_amount)}}</s>
							<span>{{moneyFormat(opsRequest.amount)}}</span>
							 | {{opsRequest.mop=='DRAGONPAY-GCASH' ? opsRequest.pmethod : opsRequest.mop}}
						</td>
						</tr>
						<tr v-if="opsRequest.less_amount>0">
							<th class="text-danger fw-semibold">Less Amount</th>
							<td class="text-danger fw-semibold">{{ moneyFormat(opsRequest.less_amount) }}</td>
						</tr>
						<tr v-if="opsRequest && opsRequest.c_source === 'bday60' && opsRequest.optiontype.includes('1200M') && opsRequest.mop=='BANK_TRANSFER' && opsRequest.status!='S'">
							<td colspan="2">
								<div class="block block-rounded bg-warning-light mb-0">
									<div class="block-content block-content-full">
										<p class="fw-bold">Do a fund transfer to the bank details below:</p>
										<table>
											<tbody>
												<tr>
													<td>Bank Name</td>
													<th class="ps-2">BDO Savings Account</th>
												</tr>
												<tr>
													<td>Account Number</td>
													<th class="ps-2">00412-016-5097</th>
												</tr>
												<tr>
													<td>Account Name</td>
													<th class="ps-2">Bo Sanchez Inc.</th>
												</tr>
												<tr>
													<td>Amount</td>
													<th class="ps-2">{{moneyFormat(opsRequest.amount)}}</th>
												</tr>
											</tbody>
										</table>
										<div class="mt-4">
											<h6>Instructions</h6>
											<ol>
												<li>Please email your proof of payment to <span class="text-info">support@trulyrichclub.com</span></li>
												<li>We will get back to you within 2-3 banking days.</li>
											</ol>
										</div>
									</div>
								</div>
							</td>
						</tr>
						<tr v-if="opsRequest.mop=='PAYNAMICS'">
							<th>Payment Channel</th>
							<td>
								<select v-model="form.pchannel" class="form-control" style="appearance:auto;">
									<optgroup label="Wallet">
										<option value="gc">GCash</option>
										<option value="shopeepay_ph">Shopee Pay Philippines</option>
										<option value="paymaya_ph">Paymaya Philippines</option>
									</optgroup>
									<optgroup label="Bank Over The Counter">
										<option value="ubp_ph">Unionbank Philippine Branches</option>
										<option value="rbank_ph">Robinsons Bank</option>
									</optgroup>
									<optgroup label="Nonbank Over The Counter">
										<option value="ecpay_ph">Ecpay Network Philippines</option>
										<option value="711_ph">711 Network Philippines</option>
										<option value="smbills_ph">SM Bills Payment Network</option>
									</optgroup>
									<optgroup label="Credit Card">
										<option value="bdo_cc_ph">Banco De Oro Acquirer</option>
									</optgroup>
									<optgroup label="Online Bank Transfer">
										<option value="bpi_ph">Bank of the Philippine Islands</option>
										<option value="ubponline_ph">Union Bank of the Philippines</option>
										<option value="instapay_qr_ph">All Philippine banks that is supported by Instapay QR or QR PH</option>
									</optgroup>
								</select>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="payment_available==true" class="mb-3">
				<div class="text-end">
					<button @click="modalPaymentMethod.toggleModal()" type="button" class="btn btn-outline-info btn-sm">Change Payment</button>
				</div>
			</div>
			<div v-if="opsRequest.mop == 'CARD'" class="form-group mb-4">
				<p>Please enter your credit/debit card details below:</p>
				<Stripe @accept-token="acceptToken" ref="stripe" />
				<div v-if="form.errors.card" class="invalid-feedback d-block">
					<i class="fa fa-exclamation-circle"></i>
					{{ form.errors.card }}
				</div>
			</div>
			<div v-if="opsRequest.mop === 'CARD'" class="mb-4">
				<div class="form-check">
					<input
						v-model="form.agree"
						class="form-check-input"
						type="checkbox"
						:value="true"
						id="register3-terms"
						name="register3-terms"
					/>
					<label class="form-check-label" for="register3-terms">
						I agree with the terms & conditions.
					</label>
				</div>
			</div>
		</div>

		<div v-if="(opsRequest && opsRequest.mop != 'OVER_THE_COUNTER' && opsRequest.mop != 'BANK_TRANSFER') || !opsRequest">
			<div class="row g-sm">
				<div class="col-12 mb-2">
					<button
						type="submit"
						class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
						:disabled="
							form.processing ||
							(form.step > 1 && opsRequest.mop === 'CARD' && !form.token) ||
							(form.step > 1 && opsRequest.mop === 'CARD' && !form.agree)
						"
					>
						<div
							v-if="form.processing"
							class="spinner-border spinner-border-sm text-text"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<span v-if="!form.processing">
							{{ form.step > 1 ? 'Pay Now!' : 'Next' }}
						</span>
					</button>
				</div>
			</div>
			<div v-if="!form.processing && form.step == 1" class="row g-sm mb-4">
				<div class="col-sm-6 mb-1">
					<inertia-link
						:href="route('login')"
						class="btn btn-alt-secondary w-100"
					>
						Sign in
					</inertia-link>
				</div>
				<div class="col-sm-6 mb-1">
					<inertia-link
						:href="route('reset-password')"
						class="btn btn-alt-secondary w-100"
					>
						Reset password
					</inertia-link>
				</div>
			</div>
		</div>
		
	</form>
	<div class="block-content text-center">
		<img
			src="/media/logo/poweredbystripe.png"
			alt="security"
			style="width: 150px"
		/>
		<div class="mt-3">Your referring affiliate is: {{ sponsor ?? 'None' }}</div>
	</div>

	<terms-and-conditions ref="termsAndConditionsModal" />


	<modal v-if="opsRequest" ref="modalPaymentMethod" size="modal-md">
		<template #title>PAYMENT METHOD</template>
		<template #body>
			<div class="row">
				<p v-if="form.errors.mop_change" class="text-center h5 text-danger fw-bold">{{form.errors.mop_change}}</p>
				<div v-if="opsRequest.mop!='CARD'" class="col-6">
					<div class="form-check form-block mb-4">
						<input
							v-model="form.mop"
							class="form-check-input"
							type="radio"
							:value="'CARD'"
							id="card"
							name="payment_method"
						/>
						<label class="form-check-label" for="card">
							<span
								class="d-flex align-items-center"
								style="
									background-image: url(/media/logo/stripe-logo.png);
									background-size: contain;
									background-repeat: no-repeat;
									background-position: center;
									height: 80px;
								"
							>
							</span>
						</label>
					</div>
				</div>
				<div v-if="opsRequest.c_source === 'bday60' && opsRequest.optiontype.includes('1200M') && opsRequest.mop!='BANK_TRANSFER'" class="col-6">
					<div class="form-check form-block mb-4">
						<input
							v-model="form.mop"
							class="form-check-input"
							type="radio"
							:value="'BANK_TRANSFER'"
							id="bank_transfer"
							name="payment_method"
						/>
						<label class="form-check-label" for="bank_transfer">
							<span
								class="d-flex align-items-center"
								style="
									background-image: url(/media/logo/bank_transfer.png);
									background-size: contain;
									background-repeat: no-repeat;
									background-position: center;
									height: 80px;
								"
							>
							</span>
						</label>
					</div>
				</div>
				<div v-if="opsRequest.mop!='DRAGONPAY' && [null,'','ph'].includes(form.event_source) && payment_available" class="col-6">
					<div class="form-check form-block mb-4">
						<input
							v-model="form.mop"
							class="form-check-input"
							type="radio"
							:value="'DRAGONPAY'"
							id="dragonpay"
							name="payment_method"
						/>
						<label class="form-check-label" for="dragonpay">
							<span
								class="d-flex align-items-center"
								style="
									background-image: url(/media/logo/dragonpay.png);
									background-size: contain;
									background-repeat: no-repeat;
									background-position: center;
									height: 80px;
								"
							>
							</span>
						</label>
					</div>
				</div>
				<div v-if="opsRequest.mop!='DRAGONPAY-GCASH' && [null,'','ph'].includes(form.event_source) && payment_available && !(isBirthdayLifetimeCheckout && isLifetimeSubscription)" class="col-6">
					<div class="form-check form-block mb-4">
						<input
							v-model="form.mop"
							class="form-check-input"
							type="radio"
							:value="'DRAGONPAY-GCASH'"
							id="dragonpay_gcash"
							name="payment_method"
						/>
						<label class="form-check-label" for="dragonpay_gcash">
							<span
								class="d-flex align-items-center"
								style="
									background-image: url(/media/logo/gcash.png);
									background-size: contain;
									background-repeat: no-repeat;
									background-position: center;
									height: 80px;
								"
							>
							</span>
						</label>
					</div>
				</div>
				<div v-if="opsRequest.mop!='OVER_THE_COUNTER' && ['noph','ph'].includes(form.event_source) && payment_available" class="col-6">
					<div class="form-check form-block mb-4">
						<input
							v-model="form.mop"
							class="form-check-input"
							type="radio"
							:value="'OVER_THE_COUNTER'"
							id="over_the_counter"
							name="payment_method"
						/>
						<label class="form-check-label" for="over_the_counter">
							<span
								class="d-flex align-items-center"
								style="
									background-image: url(/media/logo/overthecounter.png);
									background-size: contain;
									background-repeat: no-repeat;
									background-position: center;
									height: 80px;
								"
							>
							</span>
						</label>
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<button @click="changePaymentMethod" type="button" class="btn btn-success btn-sm"
				:disabled="form.step > 1 && form.processing"
			>
				<div
					v-if="form.processing"
					class="spinner-border spinner-border-sm text-white"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Change
			</button>
		</template>
	</modal>

</template>

<script>
import GuestLayout from '../Layouts/GuestLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default { layout: GuestLayout }
</script>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3'
import Stripe from '../Shared/Components/Stripe'
import { computed, ref, watch } from 'vue'
import TermsAndConditions from '../Shared/Components/Modals/TermsAndConditions'

const props = defineProps({
	sponsor: String,
	flash: Object,
	subscriptions: Object,
	txnid: String,
	c_source: String,
	test: String,
	isEvent: String,
	opsRequest: Object,
	investment_plan: Object,
})

const membershipBenefits = {
	SILVER: [
		'Mutual Funds Guidance',
		'eCom Seminar Bonus Video',
		'Daily God Whispers',
		'TRC Silver Education Video Library',
		'and many more!',
	],
	GOLD: [
		'Weekly Exclusive Live Shows',
		"BOSS (Bo's Strategic Stocks)",
		'Stock Market Guidance',
		'eCom Seminar Bonus Video',
		'Daily God Whispers',
		'TRC Education Video Library',
		'Free access to online TRC events',
		'3 complete eBooks',
		'and many more!',
	],
	DIAMOND: [
		'Quarterly Physical Gathering with keynote speakers',
		'Mutual Funds Guidance',
		'Exclusive Diamond Viber Group',
		'Weekly Exclusive Live Shows',
		"BOSS (Bo's Strategic Stocks)",
		'Stock Market Guidance',
		'eCom Seminar Bonus Video',
		'Daily God Whispers',
		'TRC Education Video Library',
		'Free access to online TRC events',
		'3 complete eBooks',
		'Access to TRC Communications Hub',
		'and many more',
	],
	PLATINUM: [
		'Quarterly Physical Gathering with keynote speakers',
		'Mutual Funds Guidance',
		'Exclusive Platinum Viber Group',
		'Weekly Exclusive Live Shows',
		"BOSS (Bo's Strategic Stocks)",
		'Stock Market Guidance',
		'eCom Seminar Bonus Video',
		'Daily God Whispers',
		'TRC Education Video Library',
		'Free access to online TRC events',
		'Free access to TRC Stock Market Seminars',
		'3 complete eBooks',
		'Access to TRC Communications Hub',
		'and many more!',
	],
}


const stripe 					= ref(null)
const modalPaymentMethod 		= ref(null)
const termsAndConditionsModal 	= ref(null)
const checkoutRememberKey 		= 'Checkout:' + (Array.isArray(props.subscriptions) && props.subscriptions.length > 0 ? props.subscriptions[0].alias : 'default')

const form = useForm(checkoutRememberKey, {
	txnid: null,
	fname: null,
	lname: null,
	email: null,
	username: null,
	mobile: null,
	country_code: null,
	country_calling_code: null,
	bday: null,
	subscription: null,
	coupon_code: null,
	mop: 'CARD',
	pmethod: null,
	pchannel: null,
	token: null,
	pchannel: "",
	agree: false,
	c_source: props.c_source,
	event_source: props.isEvent,
	step: 1,
	is_lifetime: false,
	test : props.test,
	investment_plan: props.investment_plan,
})

const currentSubscription = computed(() => {
	if (!Array.isArray(props.subscriptions)) return null

	return props.subscriptions.find((subscription) => String(subscription.prod_id) === String(form.subscription))
		|| props.subscriptions[0]
		|| null
})

const benefitMembership = computed(() => {
	const alias = String(currentSubscription.value?.alias || '').toUpperCase()

	if (alias.includes('SILVER')) return 'SILVER'
	if (alias.includes('DIAMOND')) return 'DIAMOND'
	if (alias.includes('PLATINUM')) return 'PLATINUM'

	return 'GOLD'
})

const checkoutBenefits = computed(() => membershipBenefits[benefitMembership.value] || membershipBenefits.GOLD)

const birthMonths = [
	{ value: '01', label: 'January' },
	{ value: '02', label: 'February' },
	{ value: '03', label: 'March' },
	{ value: '04', label: 'April' },
	{ value: '05', label: 'May' },
	{ value: '06', label: 'June' },
	{ value: '07', label: 'July' },
	{ value: '08', label: 'August' },
	{ value: '09', label: 'September' },
	{ value: '10', label: 'October' },
	{ value: '11', label: 'November' },
	{ value: '12', label: 'December' },
]

const currentYear = new Date().getFullYear()
const birthYears = Array.from({ length: 121 }, (_value, index) => currentYear - index)

const birthdayParts = (birthday) => {
	if (!birthday) return { year: '', month: '', day: '' }

	const parts = birthday.split('-')

	return {
		year: parts[0] || '',
		month: parts[1] || '',
		day: parts[2] || '',
	}
}

const initialBirthday = birthdayParts(form.bday)
const birthMonth = ref(initialBirthday.month)
const birthDay = ref(initialBirthday.day)
const birthYear = ref(initialBirthday.year)

const daysInBirthMonth = computed(() => {
	if (!birthMonth.value) return 31

	const year = birthYear.value ? Number(birthYear.value) : currentYear

	return new Date(year, Number(birthMonth.value), 0).getDate()
})

const birthDays = computed(() => {
	return Array.from({ length: daysInBirthMonth.value }, (_value, index) => String(index + 1).padStart(2, '0'))
})

const updateBirthday = () => {
	form.bday = birthMonth.value && birthDay.value && birthYear.value
		? `${birthYear.value}-${birthMonth.value}-${birthDay.value}`
		: null
}

const setBirthdayParts = (birthday) => {
	const parts = birthdayParts(birthday)

	birthMonth.value = parts.month
	birthDay.value = parts.day
	birthYear.value = parts.year
}

watch([birthMonth, birthYear], () => {
	if (birthDay.value && Number(birthDay.value) > daysInBirthMonth.value) {
		birthDay.value = ''
	}

	updateBirthday()
})

watch(birthDay, updateBirthday)

const onInput = (number, phoneObject, input) => {
	const rawNumber = typeof number === 'string' ? number : null
	const formattedNumber = phoneObject?.valid && typeof phoneObject?.formatted === 'string'
		? phoneObject.formatted
		: null
	const mobileNumber = formattedNumber || rawNumber || input?.value || null

	if (mobileNumber !== null) {
		form.mobile = mobileNumber
	}

	if (phoneObject?.countryCallingCode) {
		form.country_calling_code = phoneObject.countryCallingCode
	}
}

const onCountryChange = (countryObject) => {
	form.country_code = countryObject.iso2
}

const payment_available = ref(true);
const isLifetimeSubscription = computed(() => String(currentSubscription.value?.prod_id || form.subscription || '').includes('1200M'))
const isBirthdayLifetimeCheckout = computed(() => props.c_source === 'bday60' || props.opsRequest?.c_source === 'bday60')
const defaultLifetimeMop = () => isBirthdayLifetimeCheckout.value ? 'BANK_TRANSFER' : 'CARD'

if (!props.txnid && !form.subscription && isBirthdayLifetimeCheckout.value && isLifetimeSubscription.value) {
	form.subscription = currentSubscription.value.prod_id
	form.mop = defaultLifetimeMop()
	payment_available.value = false
	form.is_lifetime = true
}

const changePaymentMethod = ()=>{
	form.post(route('post.checkout-payment-method'),{
		onSuccess: ()=>{
			modalPaymentMethod.value.toggleModal();
		}
	})
}

const submit = () => {
	form
		.transform((data) => ({
			...data,
			username: data.email,
		}))
		.post(route('post.checkout'), {
			preserveState: true,
			preserveScroll: true,
			onError: (errors)=>{
				if(form.step==1)
				{
					
					var fields = ['fname','lname','email','bday','mobile','subscription','coupon_code'];
					//Check if error exist and focus the first field.
					for (var i = 0; i < fields.length; i++) {

						var found = false;

						for (const [key, value] of Object.entries(form)) {

							if(fields[i]==key){

								if(form.errors[key]){
									var  el = document.getElementById(key);
									if(key=='mobile'){
										el = document.getElementsByClassName("vti__input")[0];
									}else if(key=='subscription'){
										el = document.getElementsByClassName("subscription")[0];
									}else if(key=='bday'){
										el = document.getElementById("bday_month");
									}

									el.focus();	

									found = true;

									break;
								}
							}
						}

						if(found==true){
							break;
						}
					}
				}
			}
		})
}

const checkError = (_e)=>{
	console.log(_e);
}

const acceptToken = (token) => {
	form.token = token
}

const moneyFormat = (amount)=>{
	let format = new Intl.NumberFormat('en-US', {
	    style: 'currency',
	    currency: 'PHP',
	});
	return format.format(amount);
}

if (props.txnid && props.opsRequest) {
	form.txnid = props.opsRequest.txnid
	form.fname = props.opsRequest.fname
	form.lname = props.opsRequest.lname
	form.email = props.opsRequest.email
	form.username = props.opsRequest.username
	form.mobile = props.opsRequest.mobile
	form.country_code = props.opsRequest.country_code
	form.bday = props.opsRequest.bday
	setBirthdayParts(form.bday)
	form.subscription = props.opsRequest.optiontype
	form.mop = props.opsRequest.mop
	form.pmethod = props.opsRequest.pmethod
	form.pchannel = props.opsRequest.pchannel
	form.step = 2
	form.event_source = props.opsRequest.event_source
	form.test = props.test

	if(form.subscription.includes("1M"))
	{
		form.mop 				= 'CARD';
		form.pmethod 			= null;
		form.pchannel 			= null;
		payment_available.value = false;
		form.is_lifetime 		= false;
	}else if(form.subscription.includes("1200M")){
		form.mop 				= isBirthdayLifetimeCheckout.value ? props.opsRequest.mop : defaultLifetimeMop();
		form.pmethod 			= null;
		form.pchannel 			= null;
		payment_available.value = false;
		form.is_lifetime 		= true;
	}
}

watch(()=>form.subscription,(value)=>{
	
	if(value && value.includes("1M"))
	{
		form.mop 				= 'CARD';
		form.pmethod 			= null;
		form.pchannel 			= null;
		payment_available.value = false;
		form.is_lifetime 		= false;
	}else if(value && value.includes("1200M")){
		form.mop 				= defaultLifetimeMop();
		form.pmethod 			= null;
		form.pchannel 			= null;
		payment_available.value = false;
		form.is_lifetime 		= true;
	}else
	{
		payment_available.value = true;
		form.is_lifetime 		= false;
	}
})

watch(
	() => form.mop,
	(payment_method) => {

		form.pmethod 	= null;
		form.pchannel 	= null;

		if (payment_method == 'BANK_TRANSFER' || payment_method == 'OVER_THE_COUNTER' || payment_method == 'MANUAL' || payment_method == 'DRAGONPAY' || payment_method == 'DRAGONPAY-GCASH' || payment_method == 'PAYNAMICS'){
			
			form.token = null;
			
			if(payment_method=='DRAGONPAY-GCASH')
			{
				form.pmethod 	= 'GCASH';
				form.pchannel 	= 'GCSH';
			}
		}
	}
)

watch(
	() => form.agree,
	(agree) => {
		if (agree) termsAndConditionsModal.value.toggleModal()
	}
)

watch(
	() => props.txnid,
	(txnid) => {
		
		if(txnid==null)
		{
			fbq('trackSingle', window.fbpixelid,'InitiateCheckout');
			ttq.track('InitiateCheckout');
		}else{
			fbq('trackSingle', window.fbpixelid,'CompleteRegistration');

			ttq.identify({
		        email 		: props.opsRequest.email,
		        phone_number: props.opsRequest.mobile,
		  	})

			ttq.track('CompleteRegistration');
		}


		if (txnid && props.opsRequest) {
			form.step = 2
			form.txnid = props.opsRequest.txnid
			form.test = props.test
		}
	}
)
</script>
